export const realtorData = {
  email: 'm.benitez@unne.cl',
  phone:'966723811'
};
